import { StyledLink, StyledNavLink } from './styles'

export const Link = ({ external, to = '', ...props }) => {
  const LinkComp = external ? StyledLink : StyledNavLink
  return <LinkComp to={to} {...props} />
}
